import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RaceSignupComponent} from '../race-signup/race-signup.component';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {SeasonsService} from '../seasons.service';
import {interval} from 'rxjs';
import {ComponentsDialogDemoDialogComponent} from '../../components/components-dialog/components-dialog.component';
import {RaceDetailModalComponent} from '../../events/race-detail-modal/race-detail-modal.component';
import {MatDialog} from '@angular/material';
import {GlobalService} from '../../../global.service';
import {Router} from '@angular/router';
import {ConfirmDialogService} from '../../../shared/confirm-dialog/confirm-dialog.service';
import {ToastrService} from 'ngx-toastr';


@Component({
  selector: 'elastic-upcoming-sessions',
  templateUrl: './upcoming-sessions.component.html',
  styleUrls: ['./upcoming-sessions.component.scss']
})
export class UpcomingSessionsComponent implements OnInit {

  @Input() event: any;
  @Input() own: boolean = false;
  @Output() registered = new EventEmitter<string>();
  @Output() sessionDay = new EventEmitter<string>();
  @Input() sessionDate = '';
  @Input() singleColumn = false;
  @Input() alltogether = false;
  breakpoint = 3;



  constructor(private toastr: ToastrService, private confirmDialogService: ConfirmDialogService, private seasonsService: SeasonsService, private cdr: ChangeDetectorRef, private dialog: MatDialog, private globalService: GlobalService, private router: Router) { }

  onResize(event) {
    this.breakpoint = this.singleColumn ? 1 : (event.target.innerWidth <= 800) ? 1 : 3;
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.innerText = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    /*
    const options = {
      title: 'Lets go race!',
      message: 'Session # copied to clipboard! Paste it now in the ACC server browser to find your server!',
      cancelText: '',
      confirmText: 'OK, thanks'
    };
    this.confirmDialogService.open(options);
    this.confirmDialogService.confirmed().subscribe(confirmed => {
      if (confirmed) {

      }
    });
    */

    this.toastr.success(val + ' copied to clipboard! Paste it now in the ACC server browser to find your server!');

  }

  ngOnInit() {

    if (this.alltogether) {
      this.event.upcoming2 = this.event.upcoming_all2;
    }

    this.breakpoint =  this.singleColumn ? 1 : (window.innerWidth <= 800) ? 1 : 3;
  }

  openRaceModal(event, race) {

    this.dialog.open(RaceDetailModalComponent, {
      disableClose: false, data: {event_id: event, race_id: race}, minWidth: window.innerWidth - 400 < 200 ? window.innerWidth - 10 : window.innerWidth - 400, maxWidth: window.innerWidth - 400 < 200 ? window.innerWidth - 10 : window.innerWidth - 400
    }).afterClosed().subscribe(result => {

    });
  }

  updateUpcoming($event) {
    this.sessionDay.emit($event.value);
    this.sessionDate = $event;
  }

  openBroadcaster(broadcaster) {

    window.open('https://www.twitch.tv/' + broadcaster.twitch_channel);

  }

  getSlots(session) {



  }

}
